var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-find"},[_c('wj-image',{staticClass:"notfind-img",attrs:{"src":require('@/assets/images/404.png'),"alt":"页面404"}}),_c('div',{staticClass:"f16"},[_vm._v("糟糕，页面被带走了")]),_c('wj-button',{staticClass:"back-btn",attrs:{"type":"primary","size":"medium"},on:{"click":_vm.backToHome}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }